import { render, staticRenderFns } from "./DelegationInfoDelegationRateView.vue?vue&type=template&id=965fd2ce&scoped=true&"
import script from "./DelegationInfoDelegationRateView.vue?vue&type=script&lang=js&"
export * from "./DelegationInfoDelegationRateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965fd2ce",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VRow,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('965fd2ce')) {
      api.createRecord('965fd2ce', component.options)
    } else {
      api.reload('965fd2ce', component.options)
    }
    module.hot.accept("./DelegationInfoDelegationRateView.vue?vue&type=template&id=965fd2ce&scoped=true&", function () {
      api.rerender('965fd2ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation-info/DelegationInfoDelegationRateView.vue"
export default component.exports